import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AppContentView from '@crema/core/AppContentView';
import { useAuthMethod, useAuthUser } from '../../utility/AuthHooks';
import {
  useLayoutActionsContext,
  useLayoutContext,
} from '../../utility/AppContextProvider/LayoutContextProvider';
import AuthWrapper from './AuthWrapper';
import { useUrlSearchParams } from 'use-url-search-params';
import { useSidebarActionsContext } from '../../utility/AppContextProvider/SidebarContextProvider';
import Layouts from './Layouts';
import { onGetMenuApp } from 'redux/actions/Menu';

const AppLayout = () => {
  const dispatch = useDispatch();
  const { navStyle } = useLayoutContext();
  const { loginUser } = useAuthMethod();
  const { isAuthenticated } = useAuthUser();
  const { updateNavStyle } = useLayoutActionsContext();
  const { updateMenuStyle, setSidebarBgImage } = useSidebarActionsContext();
  const AppLayout = Layouts[navStyle];
  const [params] = useUrlSearchParams();

  useEffect(() => {
    if (params.layout) updateNavStyle(params.layout);
    if (params.menuStyle) updateMenuStyle(params.menuStyle);
    if (params.sidebarImage) setSidebarBgImage(true);
  }, [
    params.layout,
    params.menuStyle,
    params.sidebarImage,
    updateNavStyle,
    updateMenuStyle,
    setSidebarBgImage,
  ]);

  useEffect(() => {
    const token = sessionStorage.getItem('token')
    loginUser(token)
    // dispatch(onGetMenuApp())
  }, [])

  return (
    <>
      {isAuthenticated ? (
        <AppLayout />
      ) : (
        <AuthWrapper>
          <AppContentView />
        </AuthWrapper>
      )}
    </>
  );
};

export default React.memo(AppLayout);
